import { REGEX_CONFIG } from 'app/shared/utils/regex-utils';
import { alarmToggleActions } from '../../actions';
import { Section } from '../../models';
import { EdgeRlAlarmFieldIds, EdgeRlSectionIds } from './base-config-models';
import { field } from '../../core/field-schema';
import { required, pattern } from '../../core/validator-builders';
import { EdgeRlLocationCardState } from './models';
import { roundToDecimal } from '../../models/utils';

const getValidators = (isMetric: boolean) => {
    if (isMetric) {
        return [
            pattern({
                value: REGEX_CONFIG.numeric0_100000With1DecimalPlacesPattern,
                message: 'COMMON.EDGE_RL_MANHOLE_DEPTH_METRIC_ERROR',
            }),
        ];
    } else {
        return [
            pattern({
                value: REGEX_CONFIG.numeric0_100000With2DecimalPlacesPattern,
                message: 'COMMON.EDGE_RL_MANHOLE_DEPTH_NON_METRIC_ERROR',
            }),
        ];
    }
};

export const configureAlarms = (state: EdgeRlLocationCardState): Section => {
    const settings = state.settings;
    const config = state.monitorConfiguration;

    const depthAlarmValidators = [required(), ...getValidators(settings.isMetric)];

    return {
        info: {
            id: EdgeRlSectionIds.ConfigureAlarms,
            title: 'ADD_EDIT.ADD_EDIT_CONFIGURE',
            displayTitle: true,
            expandable: true,
            expanded: false,
            preserveOldValues: false,
        },
        rows: [
            {
                info: {
                    id: 'high-level-alarms-row',
                    panelClass: 'each-configure-alarm',
                },
                items: [
                    field.toggle(EdgeRlAlarmFieldIds.HighLevelEnable, 'highLevelEnable', {
                        placeholder: 'COMMON.HIGH_LEVEL_ALARM',
                        panelClass: 'alarm-slide-toggle',
                        value: config?.highlevelenable ?? false,
                        events: {
                            onChange: (value) => alarmToggleActions(value, EdgeRlAlarmFieldIds.HighLevelThreshold, depthAlarmValidators),
                        },
                    }),
                    field.number(EdgeRlAlarmFieldIds.HighLevelThreshold, 'highLevelThreshold', {
                        placeholder: 'COMMON.DEPTH_THRESHOLD_OF_HIGH_LEVEL',
                        placeholderSuffix: settings.depthUnit,
                        panelClass: 'alarm-input',
                        value: roundToDecimal(config?.highlevelthreshold, 1),
                        disabled: config && config.highlevelenable ? false : true,
                        validators: depthAlarmValidators,
                    }),
                ],
            },
        ],
    };
};
